import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Mom from './Mom'


ReactDOM.render(
  <React.StrictMode>
    <Mom />
  </React.StrictMode>,
  document.getElementById('root')
);


